import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=1bd57cc0"
import script from "../../controllers/teacher/teacher-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher/teacher-edit.js?vue&type=script&lang=js&external"
import style0 from "./TeacherEdit.vue?vue&type=style&index=0&id=1bd57cc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports